import React, { useState, useEffect, useRef } from "react";
import axios from 'axios';
import { API_URL } from '../../../utils/Common';
import Modal from "../../sharecomponents/Modal";

const initForm = Object.freeze({
  id: 0,
  nombre: '',
  des: '',
});

const btnStyle = {
    marginTop: '1.6rem',
    background: '#7b341e',
    color: '#fff'
};

const tStyle = {
  width: '150px',
}

const AreasNomina = () => {

  const modalRef = useRef();

  useEffect(() => {
    getAreas();
  }, [])

  const [form, setForm] = useState(initForm);
  const [areas, setAreas] = useState([]);
  const [area, upArea] = useState({});

  const guardar = (e) => {
    e.preventDefault();

    if ( form.nombre !== '' ) {
        axios.post(API_URL + '/nomina/set-area', form)
          .then(r => {
            console.log(r);
            setForm(initForm);
            getAreas();
          })
          .catch(e => console.log(e));
    } // -- if
    else {
      console.log('error');
    }
  } // -- guardar

  const handleChange = e => {
    setForm({
         ...form,
         [e.target.name]: e.target.value,
      });
  }

  const eliminar = (item) => {
    upArea({...item});
    modalRef.current.showModal();
  }

  const actionModal = () => {
    axios.post(API_URL + '/nomina/eliminar-area', { id: area.id })
      .then(r => {
        console.log(r.data);
        modalRef.current.hideModal();
        getAreas();
      }).catch(e => console.log(e));
  }

  const toEdit = (item) => {
    setForm({...item});
  }

  function getAreas() {
    axios.get(API_URL+'/nomina/get-areas')
      .then(r => {
        const { areas } = r.data;
        setAreas([...areas]);
      }).catch(e => console.log(e));
  }

  return (
    <React.Fragment>
      <div className="w-full p-3 right-0">
          <div className="bg-white border rounded shadow-xl">
              <div className="border-b rounded-t p-3 bg-orange-900">
                  <h5 className="font-bold uppercase text-white">Áreas</h5>
                  <p className="text-white text-sm">Configuración de Áreas</p>
              </div>
              <div className="p-5 rounded-b">
                  {/* ---- CONTENIDO --- */}
                <form className="ui mini form" onSubmit={guardar} >
                    <div className="three wide fields">
                      <div className="field">
                        <label>Nombre del Área:</label>
                        <input type="text" name="nombre" value={form.nombre} onChange={handleChange}></input>
                      </div>
                      <div className="field">
                        <label>Descripción:</label>
                        <input type="text" name="des" value={form.des} onChange={handleChange}></input>
                      </div>
                      <div className="field">
                        <button className="mini ui button" 
                          style={btnStyle}>Guardar</button>
                      </div>
                    </div>
                  </form>

                  {/** tabla de áreas **/}
                  <table className="ui small table">
                    <thead>
                      <tr>
                        <th style={tStyle}>Nombre del Área</th>
                        <th>Descripción</th>
                        <th style={tStyle}>Acciones</th>
                      </tr>
                    </thead>
                    <tbody>
                    {areas.length > 0 &&
                      areas.map((a,i) => {
                        return (
                          <tr key={i}>
                            <td>{a.nombre}</td>
                            <td>{a.des}</td>
                            <td>
                              <div className="mini ui icon buttons">
                                <button className="ui button" 
                                  onClick={() => toEdit(a)}><i className="edit icon"></i></button>
                                <button className="ui button"
                                  onClick={() => eliminar(a)}><i className="trash icon"></i></button>
                              </div>
                            </td>
                          </tr>
                        )
                      })
                    } 
                    </tbody>
                  </table>
              </div>
          </div>
      </div>
      {/** modal **/}
      <Modal
        titulo="Info"
        mensaje={`¿Seguro de remover el área de ${area.nombre}?`}
        ref={modalRef}
        actionTitle="Remover"
        actionFn={actionModal}
      />
    </React.Fragment>
  )
}

export default AreasNomina;
